import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import type { SchoolT } from '@/types/User'
import { readBooleanStorage, writeStorage } from '@/composables/useStorage'

export const useAppStore = defineStore('app', () => {
  const isReconnecting = ref(false)
  const isNetworkAbsent = ref(false)
  const isDeferringState = ref(false)
  const isPaused = ref(false)
  const isShowLoader = ref(false)
  const isDisabled = computed(() => isReconnecting.value || isNetworkAbsent.value)
  const showLearning = ref(false)
  const showSettings = ref(false)
  const showLeaderboard = ref(false)
  const isSoundEnabled = ref(readBooleanStorage('local', 'isSoundEnabled', true))
  const schools = ref<SchoolT[]>([])

  const showLoader = () => (isShowLoader.value = true)
  const hideLoader = () => (isShowLoader.value = false)
  const deferGameState = () => {
    isDeferringState.value = true
  }

  const resetAppState = () => {
    isDeferringState.value = false
    showLearning.value = false
    showSettings.value = false
    showLeaderboard.value = false
    isPaused.value = false
    isShowLoader.value = false
  }

  const toggleSound = () => {
    isSoundEnabled.value = !isSoundEnabled.value
    writeStorage('local', 'isSoundEnabled', JSON.stringify(isSoundEnabled.value))
  }

  return {
    isDisabled,
    isPaused,
    isReconnecting,
    isNetworkAbsent,
    showLearning,
    showSettings,
    showLeaderboard,
    showLoader,
    hideLoader,
    isShowLoader,
    isDeferringState,
    deferGameState,
    resetAppState,
    isSoundEnabled,
    toggleSound,
    schools
  }
})
